import { useState } from 'react'

import { Box, Text, useUnsafeEffect } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { dispatch } from 'modules/core/lib/pubSub'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { CurrencyToolTip } from 'modules/finance/components/FinancialWorkspace/components/CurrencyToolTip'
import { REFETCH_DATA_EVENT } from 'modules/finance/components/FinancialWorkspace/components/Table/const'
import { UploadPayrollButton } from 'modules/finance/components/FinancialWorkspace/components/UploadPayroll'
import { FinancialWorkspaceAvailabilities } from 'modules/finance/components/FinancialWorkspace/hooks/useFinancialWorkspaceAvailabilities'

import { Banner, localStorageKey } from './LaunchBanner'

const SOURCE = 'fw-payroll-header'

interface Props {
  availabilities: FinancialWorkspaceAvailabilities
}

export const Header = ({ availabilities }: Props) => {
  const [date] = useLocalStorage<Date>(`factorial:${localStorageKey}`)
  const [visiblePayrollButton, setVisiblePayrollButton] = useState(
    !!date || availabilities.modules.expenses
  )

  const onFinishPayroll = () => {
    dispatch({ type: REFETCH_DATA_EVENT })
  }

  useUnsafeEffect(() => {
    setVisiblePayrollButton(!!date || availabilities.modules.expenses)
  }, [date, availabilities.modules.expenses])

  const title = i18n.t('finance.financial_workspace.payroll.title')
  return (
    <Box gap="s12">
      <Box flexDirection="row" gap="s24" justifyContent="spaceBetween">
        <Box gap="s4">
          <Box flexDirection="row" gap="s4">
            <Text.Normal weight="semibold" color="grey1000">
              {title}
            </Text.Normal>
          </Box>
          <Box flexDirection="row" gap="s4">
            <Text.Normal size="200" color="grey800">
              {/* Change for Factorial One */}
              <Box style={{ color: 'hsl(var(--neutral-50))' }}>
                {i18n.t('finance.financial_workspace.payroll.description')}
              </Box>
            </Text.Normal>
            <CurrencyToolTip />
          </Box>
        </Box>
        <Box flexDirection="column">
          {visiblePayrollButton && (
            <UploadPayrollButton
              type="default"
              includeButtonIcon
              source={SOURCE}
              onFinish={onFinishPayroll}
              version="factorial-one"
            />
          )}
        </Box>
      </Box>
      <Banner
        onRestore={() => setVisiblePayrollButton(false)}
        onClose={() => setVisiblePayrollButton(true)}
      />
    </Box>
  )
}
